import { memo } from 'react';

import { useShortIdContext } from '@air/provider-short-id';

import { VideoFrameRatesSelect } from '~/components/Filters/VideoFrameRateFilter/components/VideoFrameRatesSelect';
import { type BaseStringSelectProps } from '~/components/StringSelect';
import { usePublicVideoFrameRatesList } from '~/swr-hooks/filters/usePublicVideoFrameRatesList';

type PublicVideoFrameRatesSelectProps = {
  boardId: string | undefined;
} & BaseStringSelectProps;

export const PublicVideoFrameRatesSelect = memo(({ boardId, ...props }: PublicVideoFrameRatesSelectProps) => {
  const { shortId } = useShortIdContext();

  const { data = [], isLoading } = usePublicVideoFrameRatesList({
    shortId,
    boardId,
  });

  return <VideoFrameRatesSelect isLoading={isLoading} frameRates={data} {...props} />;
});

PublicVideoFrameRatesSelect.displayName = 'PublicVideoFrameRatesSelect';
